module.exports = __webpack_public_path__ + "static/media/emailIllustration.6ddbbca4.svg";